import { translate } from '@chaika/i18n/helper';

import type { OptionType } from '../Select';

export enum DefaultOption {
    NotSelectedOptionMasculine = 'notSelectedOptionMasculine',
    NotSelectedOptionFeminine = 'notSelectedOptionFeminine',
    AnyOptionMasculine = 'anyOptionMasculine',
    AnyOptionFeminine = 'anyOptionFeminine',
    AnyOptionNeutral = 'anyOptionNeutral',
}

export const NotSelectedOptionMasculine: OptionType = {
    value: null,
    label: translate('notSelected'),
};

export const NotSelectedOptionFeminine: OptionType = {
    value: null,
    label: translate('notSelectedFeminine'),
};

export const AnyOptionMasculine: OptionType = {
    value: null,
    label: translate('any'),
};

export const AnyOptionFeminine: OptionType = {
    value: null,
    label: translate('anyFeminine'),
};

export const AnyOptionNeutral: OptionType = {
    value: null,
    label: translate('all'),
};
